export const formatCurrency = (amount: number, currencyCode: string): string => {
    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol'
    }).format(amount);
};
